import { call, put, select, takeEvery } from 'redux-saga/effects';

import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../../../actions/static-catalogs/sensor-measures';
import * as authSelectors from '../../../reducers/auth';
import * as schemas from '../../../schemas/sensor-measures';
import * as types from '../../../types/static-catalogs/sensor-measures';
import API_BASE_URL from '../../settings/apibaseurl';

/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchSensorMeasuresList(action) {
  const { sensorId, sensorModelId } = action.payload;
  try {
    const isAuth = yield select(authSelectors.isAuthenticated);
    if (isAuth) {
      const token = yield select(authSelectors.getAuthToken);
      const response = yield call(fetch, `${API_BASE_URL}/sensorMeasure/get`, {
        method: 'POST',
        body: JSON.stringify({ sensorId, sensorModelId }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      const jsonResult = yield response.json();
      if (response.status <= 300 && jsonResult.success) {
        const resultData = jsonResult.data.map((result) => camelcaseKeys(result));
        const {
          entities: { sensorMeasures },
          result //order
        } = normalize(resultData, schemas.sensorMeasures); //normalize data to byId and order
        yield put(actions.completeFetchingSensorMeasures(sensorMeasures, result));
      } else {
        const error = {
          errorMessage: jsonResult.message,
          errorNumber: jsonResult.number
        };
        // alerts.showErrorAlertFailChanges({ error });
        yield put(actions.failFetchingSensorMeasures(error));
      }
    }
  } catch (err) {
    const error = {
      errorMessage: err.toString(),
      errorNumber: -1
    };
    // alerts.showErrorAlertFailChanges({ error });
    yield put(actions.failFetchingSensorMeasures(error));
  }
}

export function* watchFetchSensorMeasuresList() {
  yield takeEvery(types.SENSOR_MEASURES_FETCH_STARTED, fetchSensorMeasuresList);
}
